import {useState, useEffect, useContext} from "react";
import { UserContext } from '../Context/UserContext';
import "../styles/mobilePitcherList.css"
import {useNavigate} from "react-router-dom"
import ColorLabels from "./ColorLabels";
import PitcherGlossary from "./PitcherGlossary";

export default function MobilePitcherList({ratingTimeframe}) {
    const {state, dispatch} = useContext(UserContext);
    const navigate = useNavigate()
    const [dataTimeframe, setDataTimeframe] = useState("ThreeYear")
    //console.log('dataTimeframe on pitcher table', dataTimeframe)
    const [filteredPitcherStats, setFilteredPitcherStats] = useState(state[`dailyPitcher${dataTimeframe}Stats`])
    const [openStatId, setOpenStatID] = useState(null)

    function expandHitterRow(statID) {
        setOpenStatID(prev => {
            return prev === statID ? null : statID
        })
    }

    useEffect(() => {
        setDataTimeframe(ratingTimeframe ? "CurrentSeason" : "ThreeYear")
    }, [ratingTimeframe])

    useEffect(() => {
        const pitcherStatsKey = `dailyPitcher${dataTimeframe}Stats`
        if (Array.isArray(state[pitcherStatsKey])) {
            setFilteredPitcherStats(state[pitcherStatsKey])
        }
        
    }, [state, dataTimeframe])

    function handleChange(e) {
        if (e.target.value === "" || e.target.value === null || e.target.value === undefined)
        setFilteredPitcherStats(state[`dailyPitcher${dataTimeframe}Stats`])
    else
        setFilteredPitcherStats(state[`dailyPitcher${dataTimeframe}Stats`].filter(stat => stat.pitcher_name.toLowerCase().includes(e.target.value.toLowerCase())))
    }

    function fetchSinglePitcherData(pitcherID) {
    fetch(`/pitchers/${pitcherID}`)
        .then(res => res.json())
        .then(data => {
            if (data) {
                dispatch({type: "fetchSinglePitcher", payload: data})
            }
            else {
                console.error("Error: Pitcher data not found")
            }
        })
    }

    function navigateToPitcherPage(pitcherName, pitcherID) {
        state.singlePitcher = []
        const formattedName = pitcherName.replace(/ /g, "-")
        fetchSinglePitcherData(pitcherID)
        navigate(`/pitcher/${formattedName}`)
        window.scrollTo(0, 0)
    }

    return (
        <div>
            <div className="searchBar">
                <label>Search A Pitcher: </label>
                <input type="text" placeholder="Ex: Justin Steele" onChange={(e) => handleChange(e)}></input>
            </div>
            <ColorLabels />
            <PitcherGlossary />
            <div className="pitcherListContainer">
            {filteredPitcherStats.map((stat) => {
                const isOpen = openStatId === stat.id
                const teamStyles = {color: state.teamColors[stat.pitcher_team].primary};
                const strikeoutRateStyles = {
                    backgroundColor: (stat.avg_hitter_matchup_k_pct >= 30.0 ? 'lightblue' : '') || (stat.avg_hitter_matchup_k_pct >= 26.0 && stat.avg_hitter_matchup_k_pct < 30.0 ? 'lightgreen' : '') || (stat.avg_hitter_matchup_k_pct > 23.0 && stat.avg_hitter_matchup_k_pct < 26.0 ? 'lightyellow' : '') || (stat.avg_hitter_matchup_k_pct <= 20.0 ? 'lightpink' : '')
                }
                const groundballRateStyles = {
                    backgroundColor: (stat.avg_hitter_matchup_gb_pct >= 50.0 ? 'lightblue' : '') || (stat.avg_hitter_matchup_gb_pct >= 46.0 && stat.avg_hitter_matchup_gb_pct < 50.0 ? 'lightgreen' : '') || (stat.avg_hitter_matchup_gb_pct > 43.0 && stat.avg_hitter_matchup_gb_pct < 46.0 ? 'lightyellow' : '') || (stat.avg_hitter_matchup_gb_pct <= 37.0 ? 'lightpink' : '')
                }
                const hardContactStyles = {
                    backgroundColor: (stat.avg_hitter_matchup_hard_contact <= 26.0 ? 'lightblue' : '') || (stat.avg_hitter_matchup_hard_contact >= 26.01 && stat.avg_hitter_matchup_hard_contact < 29.0 ? 'lightgreen' : '') || (stat.avg_hitter_matchup_hard_contact >= 29.01 && stat.avg_hitter_matchup_hard_contact < 32.0 ? 'lightyellow' : '') || (stat.avg_hitter_matchup_hard_contact >= 36.5 ? 'lightpink' : '')
                }
                const isoStyles = {
                    backgroundColor: (stat.avg_hitter_matchup_iso <= 0.129 ? 'lightblue' : '') || (stat.avg_hitter_matchup_iso >= 0.130 && stat.avg_hitter_matchup_iso < 0.140 ? 'lightgreen' : '') || (stat.avg_hitter_matchup_iso >= 0.140 && stat.avg_hitter_matchup_iso < 0.150 ? 'lightyellow' : '') || (stat.avg_hitter_matchup_iso >= 0.175 ? 'lightpink' : '')
                }
                const wobaStyles = {
                    backgroundColor: (stat.avg_hitter_matchup_woba <= 0.280 ? 'lightblue' : '') || (stat.avg_hitter_matchup_woba > 0.280 && stat.avg_hitter_matchup_woba < 0.300 ? 'lightgreen' : '') || (stat.avg_hitter_matchup_woba >= 0.300 && stat.avg_hitter_matchup_woba < 0.330 ? 'lightyellow' : '') || (stat.avg_hitter_matchup_woba >= 0.350 ? 'lightpink' : '')
                }
                const pitcherMatchupRatingStyles = {
                    backgroundColor: (stat.pitcher_matchup_rating_thirty_percent <= 5.63 ? 'lightblue' : '') || (stat.pitcher_matchup_rating_thirty_percent > 5.63 && stat.pitcher_matchup_rating_thirty_percent <= 5.85 ? 'lightgreen' : '') || (stat.pitcher_matchup_rating_thirty_percent > 5.85 && stat.pitcher_matchup_rating_thirty_percent < 6.05 ? 'lightyellow' : '') || (stat.pitcher_matchup_rating_thirty_percent >= 6.4 ? 'lightpink' : '')
                }
                return (
                    //     <td>{stat?.num_elite_rated_hitters}</td>
                    //     <td>{stat?.num_poor_rated_hitters}</td>
                    //     <td>{stat?.num_hitters_above_avg_k_pct}</td>
                    //     <td>{stat?.num_hitters_above_avg_gb_pct}</td>
                    <ul key={stat.id} className="singleGameMobileList">
                    <li className="singleGameListRow">
                        <div className="singleGameTopRow">
                                <div className="singleGameLeftContent">
                                    <div style={teamStyles} className="hitterNameAndTeam">
                                        <span className="hitterName">{stat.pitcher_name}</span>
                                        <span className="batHand">({stat.throw_hand})</span>
                                        <span className="hitterTeam">{stat.pitcher_team}</span>
                                    </div>
                                    <span className="pitcherDetails">vs {stat.hitter_team}</span>
                                </div>
                            <span style={pitcherMatchupRatingStyles} className="matchupRating">{stat.pitcher_matchup_rating_thirty_percent.toFixed(3)}</span>
                        </div>
                        <span className={isOpen ? "arrow open" : "arrow"} onClick={() => expandHitterRow(stat.id)}>▼</span>
                        {isOpen && (
                            <div className="expandedContent">
                                <div className="topExpandedRow">
                                    <h3>Matchup Stats</h3>
                                    <span>Avg Hitter Matchup Rating: <span className="matchupValue">{stat?.avg_hitter_matchup_rating?.toFixed(3)}</span></span>
                                    <span>Avg Hitter Matchup wOBA: <span className="matchupValue" style={wobaStyles}>{stat.avg_hitter_matchup_woba?.toFixed(3)}</span></span>
                                    <span>Avg Hitter Matchup ISO: <span className="matchupValue" style={isoStyles}>{stat.avg_hitter_matchup_iso?.toFixed(3)}</span></span>
                                    <span>Avg Hitter Matchup Hard Contact: <span className="matchupValue" style={hardContactStyles}>{stat?.avg_hitter_matchup_hard_contact}%</span></span>
                                    <span>Avg Hitter Matchup K Pct: <span className="matchupValue" style={strikeoutRateStyles}>{stat?.avg_hitter_matchup_k_pct.toFixed(1)}%</span></span>
                                    <span>Avg Hitter Matchup GB Pct: <span className="matchupValue" style={groundballRateStyles}>{stat?.avg_hitter_matchup_gb_pct.toFixed(1)}%</span></span>
                                </div>                                
                                <button className="moreMatchupButton"  onClick={() => navigateToPitcherPage(stat?.pitcher_name, stat?.pitcher_id)}>More on this matchup</button>
                            </div>
                            )}
                        </li>
                    </ul>
                    )
                })}
            </div>
        </div>
    )
}